export const PRIVACY_POLICY_URL = 'https://www.mckay-brothers.com/privacy';
